export default __webpack_public_path__ + "static/rayban-7f917dcc2ac68d79d5a0a7df3f6c8e38.png";